import type { AdTagInput, AdWithCreativeRefInput, ScheduleInputV5 } from '../../../../../../../../apis/graphql/types';
import { AdReviewV5, AdStatusV5 } from '../../../../../../../../apis/graphql/types';
import {
  END_OF_DAY_TIME_WITHOUT_TIMEZONE,
  START_OF_DAY_TIME_WITHOUT_TIMEZONE,
} from '../../../../../../../../common/constants';
import { adTagTypes, getPermittedAdTagEvents, isRecognizedConfig } from '../../../../../../../../configs';
import { DEFAULT_TIMEZONE } from '../../../../../../../../constants';
import type { TagSheetAd, TagSheetLineItem } from '../../../../types';

// TODO DANADS-2170: confirm that setting default position for billable tags with invalid position is acceptable
export const convertTagsToAdTagsInput = (
  tags: TagSheetAd['tags'],
  lineItemBillableEvent?: string | null
): AdTagInput[] =>
  tags.reduce<AdTagInput[]>((result, tag) => {
    if (!isRecognizedConfig(tag.type) || !isRecognizedConfig(tag.position)) {
      return result;
    }

    let event = tag.position.key;

    if (tag.type.key === adTagTypes.BILLABLE.key) {
      const permittedAdTagEvents = getPermittedAdTagEvents(tag.type.key, lineItemBillableEvent ?? undefined);
      const isPermitted = permittedAdTagEvents.some((permittedEvent) => permittedEvent.key === event);

      if (!isPermitted) {
        event = permittedAdTagEvents[0].key;
      }
    }

    result.push({
      type: tag.type.key,
      event,
      url: tag.tagUrl,
      isVerified: false,
    });

    return result;
  }, []);

export const createTagSheetAdSchedule = (
  tagSheetAd: TagSheetAd,
  lineItem: TagSheetLineItem
): ScheduleInputV5 | null => {
  if (!tagSheetAd.startDate) return null;

  return {
    timezone: lineItem.schedule?.timezone ?? DEFAULT_TIMEZONE,
    deliveryInViewerTime: lineItem.schedule?.deliveryInViewerTime ?? false,
    dateRangeList: [
      {
        startDate: `${tagSheetAd.startDate}${START_OF_DAY_TIME_WITHOUT_TIMEZONE}`,
        endDate: tagSheetAd.endDate ? `${tagSheetAd.endDate}${END_OF_DAY_TIME_WITHOUT_TIMEZONE}` : null,
        pacingShare: null,
      },
    ],
    dayPartList: [],
  };
};

export const convertTagSheetAdToAdInput = (
  tagSheetAd: TagSheetAd,
  lineItem: TagSheetLineItem,
  creativeRef: string
): AdWithCreativeRefInput | null => {
  if (isRecognizedConfig(tagSheetAd.adType)) {
    return {
      creativeRef,
      ad: {
        name: tagSheetAd.adName,
        status: AdStatusV5.Off,
        review: AdReviewV5.Draft,
        type: tagSheetAd.adType.key,
        lineItemId: lineItem.id,
        adTagList: convertTagsToAdTagsInput(tagSheetAd.tags, lineItem.billableEvent),
        schedule: createTagSheetAdSchedule(tagSheetAd, lineItem),
      },
    };
  }

  return null;
};
